export default __webpack_public_path__ + "static/media/char_select_penguin_flipped.06877dc4.png";